import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/services/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const bootAuth = async () => {
      const stored = localStorage.getItem("metho_user");
      const token = localStorage.getItem("metho_token");

      if (stored) {
        try { if (active) setUser(JSON.parse(stored)); } catch (e) {}
      }

      if (token) {
        try {
          const { data } = await api.get("/auth/me");
          if (active) setUser(data);
          localStorage.setItem("metho_user", JSON.stringify(data));
        } catch (e) {
          localStorage.removeItem("metho_token");
          localStorage.removeItem("metho_user");
          if (active) setUser(null);
        }
      }

      if (active) setLoading(false);
    };

    bootAuth();
    return () => { active = false; };
  }, []);

  const login = async (username, password) => {
    const identifier = String(username || "").trim();
    const payload = { username: identifier, password };

    let data;
    try {
      ({ data } = await api.post("/auth/login", payload));
    } catch (err) {
      throw err;
    }
    localStorage.setItem("metho_token", data.token);
    localStorage.setItem("metho_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data?.token && data?.user) {
      localStorage.setItem("metho_token", data.token);
      localStorage.setItem("metho_user", JSON.stringify(data.user));
      setUser(data.user);
    } else {
      localStorage.removeItem("metho_token");
      localStorage.removeItem("metho_user");
      setUser(null);
    }
    return data;
  };

  const logout = () => {
    localStorage.removeItem("metho_token");
    localStorage.removeItem("metho_user");
    setUser(null);
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("metho_user", JSON.stringify(data));
    } catch (e) {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

